import { IListUsersRequest } from "../../../model/security/request/list-users-request";
import { IUserListResponse } from "../../../model/security/response/user-list-response";
import { IUserDetailResponse } from "../../../model/security/response/user-detail-response";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import { ICreateUserRequest } from "../../../model/security/request/create-user-request";
import { IAccessGroupResponse } from "../../../model/base/response/access-group-response";
import { IAccessProfileResponse } from "../../../model/base/response/access-profile-response";
import { IPersonEntityResponse } from "../../../model/base/response/person-entity-response";

export type UsersManagementState = {
    usersPagedResponse: PaginationResponse<IUserListResponse>;
    usersPagedRequest: IListUsersRequest;
    selectedUser: IUserDetailResponse | null;
    isLoadingData: boolean;
    isLoadingUser: boolean;
    isDrawerOpen: boolean;
    isEditing: boolean;
    userForm: ICreateUserRequest;
    accessGroups: IAccessGroupResponse[];
    accessProfiles: IAccessProfileResponse[];
    personEntities: IPersonEntityResponse[];
    isLoadingLookups: boolean;
    passwordResetDialog: {
        open: boolean;
        userName: string;
        userEmail: string;
        newPassword: string;
    };
};

export enum ACTION_TYPES {
    setUsersPagedResponse = 'setUsersPagedResponse',
    setUsersPagedRequest = 'setUsersPagedRequest',
    setSelectedUser = 'setSelectedUser',
    setIsLoadingData = 'setIsLoadingData',
    setIsLoadingUser = 'setIsLoadingUser',
    setIsDrawerOpen = 'setIsDrawerOpen',
    setIsEditing = 'setIsEditing',
    setUserForm = 'setUserForm',
    resetUserForm = 'resetUserForm',
    setAccessGroups = 'setAccessGroups',
    setAccessProfiles = 'setAccessProfiles',
    setPersonEntities = 'setPersonEntities',
    setIsLoadingLookups = 'setIsLoadingLookups',
    setPasswordResetDialog = 'setPasswordResetDialog',
    closePasswordResetDialog = 'closePasswordResetDialog'
}

export const UsersManagementReducer = (state: UsersManagementState, action: any): UsersManagementState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setUsersPagedResponse:
            return { ...state, usersPagedResponse: payload };
        case ACTION_TYPES.setUsersPagedRequest:
            return { ...state, usersPagedRequest: payload };
        case ACTION_TYPES.setSelectedUser:
            return { ...state, selectedUser: payload };
        case ACTION_TYPES.setIsLoadingData:
            return { ...state, isLoadingData: payload };
        case ACTION_TYPES.setIsLoadingUser:
            return { ...state, isLoadingUser: payload };
        case ACTION_TYPES.setIsDrawerOpen:
            return { ...state, isDrawerOpen: payload };
        case ACTION_TYPES.setIsEditing:
            return { ...state, isEditing: payload };
        case ACTION_TYPES.setUserForm:
            return { ...state, userForm: payload };
        case ACTION_TYPES.resetUserForm:
            return {
                ...state,
                userForm: {
                    email: '',
                    password: '',
                    accessGroupId: 0,
                    name: '',
                    documentNumber: '',
                    isActive: true,
                    personEntityIds: [],
                    personCompanyIds: [],
                    entityAccesses: [],
                    confirmPassword: ''
                } as ICreateUserRequest
            };
        case ACTION_TYPES.setAccessGroups:
            return { ...state, accessGroups: payload };
        case ACTION_TYPES.setAccessProfiles:
            return { ...state, accessProfiles: payload };
        case ACTION_TYPES.setPersonEntities:
            return { ...state, personEntities: payload };
        case ACTION_TYPES.setIsLoadingLookups:
            return { ...state, isLoadingLookups: payload };
        case ACTION_TYPES.setPasswordResetDialog:
            return { ...state, passwordResetDialog: payload };
        case ACTION_TYPES.closePasswordResetDialog:
            return {
                ...state,
                passwordResetDialog: {
                    open: false,
                    userName: '',
                    userEmail: '',
                    newPassword: ''
                }
            };
        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
};
